import { getApiBasePathInfo } from 'common/helpers/getApiBasePath/getApiBasePath';

import httpRequestService from '../http/httpRequestService';
import { HTTPRequestServicePayload, Method } from '../http/types';

const onUnAuthorized = (response: Response) => {
  if (response.status === 401) {
    window.location.reload();
  }
};

type ApiRequestServicePayload = Pick<
  HTTPRequestServicePayload,
  'query' | 'body' | 'headers' | 'credentials'
> & {
  method: string;
  customHost?: string;
  customPathName?: string;
  httpMethod?: Method;
};

const { pathname, protocol, host } = getApiBasePathInfo();

const apiRequestService = <T = any>({
  method,
  httpMethod = Method.Get,
  query,
  body,
  headers,
  customHost,
  credentials,
  customPathName,
  ...requestOptions
}: ApiRequestServicePayload): Promise<T> =>
  httpRequestService({
    protocol,
    query,
    body,
    headers,
    credentials,
    host: customHost || host,
    method: httpMethod,
    pathname: `/${customPathName || pathname}${method}`,
    onError: onUnAuthorized,
    ...requestOptions,
  }) as Promise<T>;

export default apiRequestService;
